import { Controller } from "@hotwired/stimulus"

// Screener's tag filter: keeps the "Selected: ..." display text and the
// hidden tag_list[] inputs (read by the server on submit) in sync with
// whichever .tag_check boxes are checked. Rebuilds the hidden inputs from
// scratch on every sync rather than incrementally adding/removing one at a
// time -- simpler, and can't drift into duplicate/stale hidden fields.
export default class extends Controller {
  static targets = ["checkbox", "display", "hiddenContainer"]

  connect() {
    // Re-derive the display text and hidden fields for whatever's already
    // checked (e.g. a screener URL loaded with tags pre-selected via query
    // params).
    this.sync()
  }

  sync() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)

    this.displayTarget.textContent = selected.length === 0 ? "No tags selected" : selected.join(", ")

    this.hiddenContainerTarget.innerHTML = ""
    selected.forEach((value) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "tag_list[]"
      input.value = value
      this.hiddenContainerTarget.appendChild(input)
    })
  }
}
